/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Flex, Divider, Rate, ConfigProvider } from "antd";

import FormHeader from "../form/FormHeader";
import FormText from "../form/FormText";
import FormLabel from "../form/FormLabel";
import FormTextarea from "../form/FormTextarea";
import FormInputError from "../form/FormInputError";
import ShadowBox from "../core/ShadowBox";
import FormButtonSecondary from "../form/FormButtonSecondary";
import useApplyNewStore from "../../store/useApplyNewStore";
import useViewStore from "../../store/useViewStore";
import useModalStore from "../../store/useModalStore";
import { basename, isProduction } from "../../setting";
import SurveyModal from "../common/SurveyModal";

import i18n from "../../i18n";

function StepSuccess() {
  const { t } = useTranslation();
  const { isMobileView } = useViewStore((state) => state);
  const navigate = useNavigate();
  const { setStep, refno, ratingSubmit, disableRatingSubmit } = useApplyNewStore();
  const { openModalConfirm, openModalInfo, closeModalConfirm } = useModalStore();

  const goBack = () => {
    // setStep("0");
    navigate(`/${basename}`);
  };

  const SurveyContent = () => {
    const { validateRating } = useApplyNewStore();
    const { stepSuccess_rateOverall, stepSuccess_rateOverall_error, setStepSuccess_rateOverall, setStepSuccess_rateOverall_error } = useApplyNewStore();
    const { stepSuccess_rateImproveCode, stepSuccess_rateImproveCode_error, setStepSuccess_rateImproveCode, setStepSuccess_rateImproveCode_error } = useApplyNewStore();
    const { stepSuccess_rateCmt, stepSuccess_rateCmt_error, setStepSuccess_rateCmt, setStepSuccess_rateCmt_error } = useApplyNewStore();

    const handleRateImproveCodeChange = (value) => {
      const codeArray = stepSuccess_rateImproveCode ? stepSuccess_rateImproveCode.split(",") : [];
      if (codeArray.includes(value)) {
        codeArray.splice(codeArray.indexOf(value), 1);
      } else {
        codeArray.push(value);
      }

      setStepSuccess_rateImproveCode(codeArray.join(","));
      setStepSuccess_rateImproveCode_error(false);
      validateRating(true);
    }

    const isActive = (code) => {
      return stepSuccess_rateImproveCode.split(",").includes(code);
    }

    useEffect(() => {
      validateRating(true);
    }, []);

    return (
      <Flex vertical align="center" gap={24} style={{ marginTop: 30 }}>
        <FormHeader style={{ margin: 0 }}>{t("translation:apply.success.survey_modal.title")}</FormHeader>

        <Flex vertical gap={8} style={{ width: "100%", alignItems: "center" }}>
          <FormText>{t("translation:apply.success.survey_modal.Q1")}</FormText>
          <ConfigProvider
            theme={{
              token: {
                // colorPrimary: "var(--aia-bx-bright-blue-60)",
                fontSize: 30
              },
            }}
          >
            <Rate value={stepSuccess_rateOverall} onChange={(value) => {
              setStepSuccess_rateOverall(value);
              setStepSuccess_rateOverall_error(false);
              validateRating(true);
            }} style={{ fontSize: 30 }} />
          </ConfigProvider>
          {/* <FormInputError style={{ textAlign: "center" }} show={stepSuccess_rateOverall_error}>* {t("pleaseSelect", { key: t("translation:apply.success.survey_modal.Q1") })}</FormInputError> */}
        </Flex>

        {
          (stepSuccess_rateOverall !== null && stepSuccess_rateOverall !== 0) && <>
            <Flex vertical gap={8} style={{ width: "100%", alignItems: "center" }}>
              <FormText>{t(`translation:apply.success.survey_modal.${stepSuccess_rateOverall > 3 ? "Q2_above" : "Q2_below"}`)}</FormText>
              <Flex gap={12} wrap="wrap" justify="center">
                <FormButtonSecondary style={{ padding: "2px 24px 4px", backgroundColor: isActive("R001") ? "var(--aia-bx-blue-2)" : "var(--aia-bx-white)", color: isActive("R001") ? "var(--aia-bx-white)" : "var(--aia-bx-dark-blue)" }} onClick={() => { handleRateImproveCodeChange("R001"); }}>{t("translation:apply.success.survey_modal.Q2_Option1")}</FormButtonSecondary>
                <FormButtonSecondary style={{ padding: "2px 24px 4px", backgroundColor: isActive("R002") ? "var(--aia-bx-blue-2)" : "var(--aia-bx-white)", color: isActive("R002") ? "var(--aia-bx-white)" : "var(--aia-bx-dark-blue)" }} onClick={() => { handleRateImproveCodeChange("R002"); }}>{t("translation:apply.success.survey_modal.Q2_Option2")}</FormButtonSecondary>
                <FormButtonSecondary style={{ padding: "2px 24px 4px", backgroundColor: isActive("R003") ? "var(--aia-bx-blue-2)" : "var(--aia-bx-white)", color: isActive("R003") ? "var(--aia-bx-white)" : "var(--aia-bx-dark-blue)" }} onClick={() => { handleRateImproveCodeChange("R003"); }}>{t("translation:apply.success.survey_modal.Q2_Option3")}</FormButtonSecondary>
                <FormButtonSecondary style={{ padding: "2px 24px 4px", backgroundColor: isActive("R004") ? "var(--aia-bx-blue-2)" : "var(--aia-bx-white)", color: isActive("R004") ? "var(--aia-bx-white)" : "var(--aia-bx-dark-blue)" }} onClick={() => { handleRateImproveCodeChange("R004"); }}>{t("translation:apply.success.survey_modal.Q2_Option4")}</FormButtonSecondary>
              </Flex>
              <FormInputError style={{ textAlign: "center" }} show={stepSuccess_rateImproveCode_error}>* {t("pleaseSelect", { key: t(`translation:apply.success.survey_modal.${stepSuccess_rateOverall > 3 ? "Q2_above" : "Q2_below"}`) })}</FormInputError>
            </Flex>

            <Flex vertical gap={4} style={{ width: "100%" }}>
              <FormLabel htmlFor={"suggest"} style={{ margin: 0 }}>{t(`translation:apply.success.survey_modal.${stepSuccess_rateOverall > 3 ? "Q3_above" : "Q3_below"}`)}</FormLabel>
              <FormTextarea
                id="suggest"
                value={stepSuccess_rateCmt}
                onChange={e => {
                  setStepSuccess_rateCmt(e.target.value);
                  setStepSuccess_rateCmt_error(false);
                  validateRating(true);
                }}
                rows="5"
                style={{ width: "100%", minHeight: 100 }}
                placeholder={t("translation:apply.success.survey_modal.Q3_placeholder")}
                aria-label={t("translation:apply.success.survey_modal.Q3_placeholder")}
              />
              {/* <FormInputError show={stepSuccess_rateCmt_error}>* {t(`translation:apply.success.survey_modal.${stepSuccess_rateOverall > 3 ? "Q3_below" : "Q3_above"}`)}</FormInputError> */}
            </Flex>
          </>
        }
      </Flex>
    );
  }

  // const openSurvey = () => {
  //   openModalConfirm({
  //     title: "",
  //     modalConfirmPrimaryButtonText: t("submit"),
  //     modalConfirmPrimaryButtonDisabled: true,
  //     callback: async () => {
  //       const res = await ratingSubmit();

  //       if (res.status === "SUCCESS") {
  //         closeModalConfirm();
  //         openModalInfo({
  //           title: t("translation:apply.success.survey_modal.success"),
  //         });
  //       }
  //     },
  //     content: <SurveyContent />,
  //   });
  // };

  useEffect(() => {
    // if (!disableRatingSubmit) {
    //   openSurvey();
    // }
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container $isMobileView={isMobileView}>
      <Center>
        <img src={`${process.env.PUBLIC_URL}/images/success-save.svg`} alt={t("translation:apply.success.title")} style={{ width: 155, height: 155 }} />
        <FormHeader style={{ margin: 0 }}>{t("translation:apply.success.title")}</FormHeader>
        <ShadowBox style={{ backgroundColor: "var(--aia-bx-bright-blue-5)", borderColor: "transparent", justifyContent: "center", flexDirection: "column", gap: 4 }}>
          <FormText style={{ color: "var(--aia-bx-dark-blue)" }}>{t("translation:apply.success.refno")}</FormText>
          <FormText style={{ color: "var(--aia-bx-dark-blue)", fontSize: 24, lineHeight: "36px" }}><span id="preAuth-apply-reference-no">{refno}</span></FormText>
        </ShadowBox>

        <FormText style={{ textAlign: "center" }}>{t("translation:apply.success.content")}</FormText>
        {/* <FormText style={{ textAlign: "center" }}>{t("translation:apply.success.method")}</FormText> */}
      </Center>

      <Flex vertical={isMobileView} gap={24}>
        <Flex vertical gap={i18n.language === "ch" || isMobileView ? 8 : 32} flex={1}>
          <FormText style={{ textAlign: "center" }}>{t("translation:apply.success.left_title")}</FormText>
          <FormButtonSecondary id={isProduction ? "pre_auth_thankyou_progress_btn" : "pre_auth_uat_thankyou_progress_btn"} style={{ padding: "11px 24px" }} onClick={() => {
            // setStep("0");
            navigate(`/${basename}/${i18n.language}/apply/progress`);
          }}>{t("translation:apply.success.left_btn")}</FormButtonSecondary>
        </Flex>
        {
          !isMobileView &&
          <Flex>
            <Divider type={"vertical"} style={{ height: "100%" }} />
          </Flex>
        }
        <Flex vertical gap={8} flex={1}>
          <FormText style={{ textAlign: "center" }}>{t("translation:apply.success.right_title")}</FormText>
          <FormButtonSecondary id={isProduction ? "pre_auth_thankyou_claim_btn" : "pre_auth_uat_thankyou_claim_btn"} onClick={() => {
            const url = `${process.env.REACT_APP_PDF_PREFIX}/${i18n.language === "ch" ? "Medical Claims Procedure_Chi_202409.pdf" : "Medical Claims Procedure_Eng_202409.pdf"}`;
            window.open(url, '_blank');
          }}>{t("translation:apply.success.right_btn")}</FormButtonSecondary>
        </Flex>
      </Flex>

      <Flex vertical gap={4}>
        <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:apply.success.notice")}</FormText>
        <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:apply.success.notice1")}</FormText>
        <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:apply.success.notice2")}</FormText>
      </Flex>

      <Flex vertical gap={8}>
        <FormText style={{ color: "var(--aia-bx-dark-blue)" }}><b>{t("translation:apply.success.other_contact")}</b></FormText>
        <Flex vertical gap={4}>
          <Flex gap={8}>
            <Icon src={`${process.env.PUBLIC_URL}/images/email.svg`} alt="email" />
            <FormText style={{ color: "var(--aia-bx-dark-blue)" }}>mcuser@bluecross.com.hk</FormText>
          </Flex>
          <Flex gap={8}>
            <Icon src={`${process.env.PUBLIC_URL}/images/mobile.svg`} alt="phone" />
            <FormText style={{ color: "var(--aia-bx-dark-blue)" }}>2839 6333</FormText>
          </Flex>
        </Flex>
      </Flex>

      <Flex gap={16} vertical={isMobileView} justify="center">
      <SurveyModal
        refNo={refno}
      />
         {/* <FormButtonSecondary $disabled={disableRatingSubmit} style={isMobileView ? { width: "100%" } : {}} onClick={() => {
          if (!disableRatingSubmit) {
            openSurvey();
          }
        }}>{t("translation:apply.success.survey")}</FormButtonSecondary> */}
        <FormButtonSecondary style={isMobileView ? { width: "100%" } : {}} onClick={goBack}>{t("backToHome")}</FormButtonSecondary>
      </Flex>
    </Container>
  );
}

const Container = styled.section`
  display: flex;
  flex-direction: column;
  width: 95%;
  max-width: 600px;
  background-color: var(--aia-bx-white);
  ${props => props.$isMobileView ? "padding: 32px 16px;" : "padding: 32px;"}
  gap: 24px;
  margin-bottom: 0px;
  border-radius: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
`;

const Center = styled(Flex)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

export default StepSuccess;